import { Component, OnInit } from '@angular/core';
import { ThemingService } from 'src/app/theming.service';
import { AuthService } from 'src/app/auth.service';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-analytics',
  templateUrl: './analytics.component.html',
  styleUrls: ['./analytics.component.scss']
})
export class AnalyticsComponent implements OnInit {

 shopId: string = '';
   userEmail: string | null = null;
   private emailSubscription!: Subscription;
   private analyticsBaseUrl: string = environment.analyticsBaseUrl;

   constructor(public themingService: ThemingService, private authService: AuthService) {}

   async ngOnInit() {
   this.emailSubscription = this.authService.userEmail$.subscribe((email) => {
     this.userEmail = email;
   });

   this.userEmail = this.authService.getCurrentUserEmail();

   if (this.themingService && this.themingService.shopId) {
     this.shopId = this.themingService.shopId.toString();
   }
 }

   redirectToAnalytics() {
     if (!this.shopId) {
       console.error('No se pudo obtener el shopId');
       return;
     }

     const usuario = this.userEmail;
     const fecha = new Date().getTime();
     const token = btoa(`${usuario}:${fecha}:${this.shopId}`);
     const redirectUrl = `${this.analyticsBaseUrl}/auth?t=${token}`;
     window.location.href = redirectUrl;
   }
}
